<template>
<div class="text-white">
    <div class="input-field mb-14">
                <div class="rounded-[6px] w-full overflow-hidden ">
                <input v-model="state.name" type="text" placeholder="Nome" class="p-4 w-full text-1.6rem bg-transparent" />
               </div>
               <div class="input-errors" v-for="error of v$.name.$errors" :key="error.$uid">
                    <div class="error-msg">Inserire Nome</div>
                </div>    
            </div>
            <div class="input-field mb-14">
            <div class="rounded-[6px]   w-full overflow-hidden">
                <input v-model="state.lastName" type="text" placeholder="Cognome" class="p-4 w-full text-1.6rem bg-transparent" />
            </div>
            <div class="input-errors" v-for="error of v$.lastName.$errors" :key="error.$uid">
                    <div class="error-msg">Inserire Cognome</div>
                </div>  
            </div>
            <div class="input-field mb-14">
            <div class="rounded-[6px]   w-full overflow-hidden">
                <input v-model="state.phone" type="text" placeholder="Telefono" class="p-4 w-full text-1.6rem bg-transparent" />
            </div>
            <div class="input-errors" v-for="error of v$.phone.$errors" :key="error.$uid">
                    <div class="error-msg">Inserire Numero di telefono</div>
                </div>  
            </div>
            <div class="input-field mb-14">
            <div class="rounded-[6px]   w-full overflow-hidden">
                <input v-model="state.contact.email" type="text" placeholder="Email" class="p-4 w-full text-1.6rem bg-transparent" />
            </div>
            <div class="input-errors" v-for="error of v$.contact.email.$errors" :key="error.$uid">
                    <div class="error-msg">Controllare che l'email sia corretta</div>
                </div> 
            </div>
            <div class="input-field mb-14">
            <div class="rounded-[6px]   w-full overflow-hidden">
                <input v-model="state.citta" type="text" placeholder="Città" class="p-4 w-full text-1.6rem bg-transparent" />
            </div>
            <div class="input-errors" v-for="error of v$.citta.$errors" :key="error.$uid">
                    <div class="error-msg">Inserire la città</div>
                </div> 
            </div>
            <div class="input-text">
            <div class=" rounded-[6px]  w-full overflow-hidden mb-14 bg-transparent">
                <textarea v-model="state.message" placeholder="Messaggio"
                    class="p-4 w-full text-1.6rem min-h-[15rem] bg-transparent"></textarea>
            </div>
            </div>
            <div class="wrap-privacy">
            <div class="privacy flex items-center justify-center mb-8">
                
                <input id="privacy" type="checkbox" v-model="privacy" class="mr-4"/>
                <label for="privacy">Ho letto l'Informativa e acconsento al trattamento <br/>dei dati per la finalità indicata.</label>
            </div>
            </div>
            <div class="max-w-md m-auto mb-20">
                <button 
                    class="rounded-[6px] bg-black text-white text-xl w-full p-4 flex items-center justify-center"
                    @click.prevent="submit">Invia</button>
            </div>
  </div> 

</template>

<script>
import { reactive } from 'vue' // "from '@vue/composition-api'" if you are using Vue 2.x
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, maxLength } from '@vuelidate/validators'
import { kMaxLength } from 'buffer'
export default {
    name: 'form-contatti',
    setup() {
        const state = reactive({
            name: '',
            lastName: '',
            contact: {
                email: ''
            },
            citta:'',
            phone: '',
            message: '',
            privacy:false
        })
        const rules = {
            name: { required }, // Matches state.firstName
            lastName: { required }, // Matches state.lastName
            contact: {
                email: { required, email } // Matches state.contact.email
            },
            citta:{required},
            phone:{
                required, 
                minLength: minLength(5),
                maxLength: maxLength(8)
                
            }

        }

        const v$ = useVuelidate(rules, state)

        return { state, v$ }
    },
    methods: {
        async submit () {
      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        console.log('result in if', result)        
      }
      console.log(result)
      // perform async actions
    }
    }
}


</script>

<style lang="scss" scoped>

</style>